export enum FETCH_STATES {
  LOADING = "loading",
  SUCECSS = "success",
  FAILED = "failed",
}

export enum BusinessStatus {
  ACTIVATED = "active",
  DE_ACTIVATED = "deactivated",
  PARTIALLY_DEACTIVATED = "partially deactivated",
  IN_ACTIVE = "inactive",
  PENDING = "pending",
}

export enum PlanActivationStatus {
  READY = "READY",
  INITIATED = "INITIATED",
  ACTIVATED = "SUCCESS",
  FAILED = "FAILED",
  DE_ACTIVATED = "CANCELLED",
  EXPIRED = "EXPIRED",
  PENDING = "PENDING",
}

export enum PaymentStatus {
  INITIATED = "initiated",
  SUCCESS = "success",
  FAILED = "failed",
  PENDING = "pending",
}

export enum TransactionStatusEnum {
  SUCCESS = "succeeded",
  FAILED = "failed",
  PENDING = "pending",
  MAPPED = "Mapped",
}

export enum TransactionTypeEnum {
  EARNED = "EA",
  TOP_UP = "TP",
  PAYOUT = "PO",
  INSTANT_PAY = "IP",
}

export enum StripeSessionPaymentStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum PayoutMethodEnum {
  PAYPAL = "paypal",
  VENMO = "venmo",
  ZELLE = "zelle",
  CHECK = "check",
  CANADA_EFT = "canadaeft",
  CANADAEFT_PREVIEW = "canada-eft",
  DEFAULT = "default",
}

export enum StripeBrands {
  AMEX = "amex",
  DINERS = "diners",
  DISCOVER = "discover",
  EFTPOS = "eftpos_au",
  JCB = "jcb",
  MASTER = "mastercard",
  UNIONPAY = "unionpay",
  VISA = "visa",
  UNK = "unknown",
}

export enum CardPurposeEnum {
  PRE_SIGNUP = "PRE_SIGNUP",
  UPDATE_PAYMENT = "UPDATE_PAYMENT",
  ADD_PAYMENT = "ADD_PAYMENT",
}

export enum PreSignupStatusEnum {
  PENDING = "PENDING",
  ENROLLED = "ENROLLED",
  FAILED = "FAILED",
  WITHDRAWN = "WITHDRAWN",
  PROCESSED = "PROCESSED",
}

export enum PreSigninStepsEnum {
  DETAIL = "detail",
  PreRegister = "pre-register",
}

export enum OS {
  ANDROID = "android",
  IOS = "ios",
  OTHER = "other",
}
